import { useQuery } from '@tanstack/react-query';

import { getHistoryByTrackerOrAccess } from '@/api';
import { Tracker } from '@/types';

export const useHistoryTracker = (tracker: Tracker, options: { skip?: boolean } = {}) => {
  return useQuery({
    queryKey: ['HistoryNotifications', tracker.unique],
    queryFn: async () => {
      const result = await getHistoryByTrackerOrAccess(tracker);

      return result ?? [];
    },
    refetchInterval: options?.skip ? Infinity : 10000,
    enabled: !options?.skip,
    ...options,
  });
};
